export default __webpack_public_path__ + "static/media/reservation-config-modal.942e0c69.jpeg";